import { z } from 'zod';

export const zodReplaceInvoiceAssigneesPayloadSchema = z.object({
  userIds: z.array(z.uuid()),
});
